import { Outlet, useLocation } from 'react-router-dom';
import { getOrgConfig } from '../../utils/organizationConfigUtil';

const Layout = () => {
  const location = useLocation();
  const orgConfig = getOrgConfig();

  const noBgRoutes = ['/lendercontacts', '/custom-header', '/login', '/loan-conditionsnap', '/ai-loansummary', '/loancomparison',
    '/asset-depletion', '/resolve-comments', '/required-reserves', '/amdocreview', '/audit-trail', '/contactus', '/milestone-rule-execution',
    '/exception-rule-manager', '/custom-header'];

  const isSkyTPO = orgConfig.id === 'SkyTPO';
  const isQuickPriceRoute = location.pathname?.toLowerCase() === '/quickprice' || location.pathname?.toLowerCase() === '/CorrQuickPrice';
  const showWrapperClass = isSkyTPO && isQuickPriceRoute;

  const removeBg = noBgRoutes.includes(location.pathname.toLowerCase()) || showWrapperClass;

  return (
    <div className={`min-h-screen flex flex-col bg-page-background ${showWrapperClass ? `wrapper--${orgConfig.id.toLowerCase()}` : ''}`}
      style={
        removeBg
          ? {}
          : { backgroundImage: `url(${getOrgConfig().layoutBackground})` }
      }
    >
      {/* <Header /> */}
      <main className="flex-grow">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;